<template>
  <div class="detailPage">
    <div class="customer_wrap">
      <div class="customer_list">
        <div class="item">
          <div class="txt flex-rowl">
            <p class="label">客户名称：</p>
            <p>
              {{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">企业名称：</p>
            <p>{{ customerDetail.other_companystr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">职务：</p>
            <p>{{ customerDetail.other_job }}</p>
          </div>
          <div class="txt flex-between">
            <div class="flex-rowl">
              <p class="label">联系方式：</p>
              <p>{{ customerDetail.info_mobile }}</p>
            </div>
            <div class="icon_wrap flex-rowr">
              <a :href="`tel:${customerDetail.info_mobile}`"
                ><i class="iconfont icon-dianhua"></i
              ></a>

              <i
                class="iconfont icon-fuzhi copy_box"
                :data-clipboard-text="customerDetail.info_mobile"
                @click="handleCopyBtn()"
              ></i>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="txt flex-rowl">
            <p class="label">客户标签：</p>
            <p>
              {{
                customerDetail.info_tag_idstr
                  ? customerDetail.info_tag_idstr
                  : ""
              }}
            </p>
            <!-- <div class="label_list flex-rowl" v-if="customerDetail.info_tag_idstr">
              <div class="label_item">
                {{ customerDetail.info_tag_idstr }}
                <i class="iconfont icon-checkbox-checked-o"></i>
              </div>
            </div> -->
          </div>
        </div>
        <div class="item red">
          <div class="txt flex-rowl">
            <p class="label">补充分类：</p>
            <p>{{ customerDetail.other_typestr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">客户属性：</p>
            <p>{{ customerDetail.other_attrstr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">联系优先度：</p>
            <p>{{ customerDetail.other_yxdstr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">成交记录：</p>
            <p></p>
          </div>
        </div>
        <div class="item address">
          <div class="tit flex-rowl">
            <p class="label">所在地区：</p>
          </div>
          <div class="txt flex-rowl">
            <p>{{ customerDetail.other_provincename }}</p>
            <p>{{ customerDetail.other_cityname }}</p>
            <p>{{ customerDetail.other_areaname }}</p>
          </div>
          <div class="txt">
            <p>{{ customerDetail.other_address }}</p>
          </div>
        </div>
        <div class="item red">
          <div class="txt flex-rowl">
            <p class="label">当前客户归属：</p>
            <p>{{ customerDetail.info_remark }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">最新触达日期：</p>
            <p>{{ customerDetail.createdate | formatDate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="main_wrap">
      <van-sticky>
        <div class="tab_head flex-between">
          <div
            class="tab_item"
            :class="{ active: tabIndex == 0 }"
            @click="handleTab(0)"
          >
            分配记录
          </div>
          <div
            class="tab_item"
            :class="{ active: tabIndex == 1 }"
            @click="handleTab(1)"
          >
            触达记录
          </div>
        </div>
      </van-sticky>

      <div class="tab_content">
        <div class="record_wrap" v-if="tabIndex == 0">
          <template v-if="dataListF.length > 0">
            <div
              class="record_list"
              v-for="item in dataListF"
              :key="item.id"
            >
              <div class="block">
                <div class="txt red flex-rowl">
                  <p class="label">分配给：</p>
                  <p>{{ item.cmuseropenidstr }}</p>
                </div>
                <div class="txt red flex-rowl">
                  <p class="label">分配日期：</p>
                  <p>{{ item.createdate | formatDate }}</p>
                </div>
                <div class="txt red flex-rowl">
                  <p class="label">操作人：</p>
                  <p>{{ item.openidstr }}</p>
                </div>
                <div class="txt flex-rowl">
                  <p class="label">分配类型：</p>
                  <p>{{ item.gettypestr }}</p>
                </div>
              </div>
              <div class="remark">
                <h1>备注说明：</h1>
                <p>
                  {{ item.details }}
                </p>
              </div>
              <div class="more flex-rowr">
                <div class="box flex-rowc">
                  <i class="iconfont icon-gengduo"></i>
                </div>
              </div>
            </div>
          </template>

          <van-empty
            v-else-if="dataListF.length == 0 && !loadingF"
            description="暂无数据"
          />
        </div>
        <div class="record_wrap" v-if="tabIndex == 1">
          <template v-if="dataListC.length > 0">
            <div class="record_list" v-for="item in dataListC" :key="item.id">
              <div class="block">
                <div class="txt red flex-rowl">
                  <p class="label">添加人：</p>
                  <p>{{ item.customeridstr }}</p>
                </div>
                <div class="txt red flex-rowl">
                  <p class="label">触达日期：</p>
                  <p>{{ item.createdate | formatDate }}</p>
                </div>
                <div class="txt flex-rowl">
                  <p class="label">联系形式：</p>
                  <p>{{ item.gettypestr }}</p>
                </div>
                <div class="txt flex-rowl">
                  <p class="label">最近联系情况：</p>
                  <p>{{ item.getstatestr }}</p>
                </div>
                <div class="txt flex-rowl">
                  <p class="label">联系结果：</p>
                  <p>{{ item.resultstr }}</p>
                </div>
              </div>
              <div class="remark">
                <h1>情况说明：</h1>
                <p>
                  {{ item.details }}
                </p>
              </div>
              <div class="more flex-rowr">
                <div class="box flex-rowc">
                  <i class="iconfont icon-gengduo"></i>
                </div>
              </div>
            </div>
          </template>
          <van-empty
            v-else-if="dataListC.length == 0 && !loadingC"
            description="暂无数据"
          />
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="bottom-operation flex-between">
      <div class="arr" @click="handleReturn">
        <i class="iconfont icon-bottom"></i>
      </div>
      <div class="item flex-rowc" @click="handleGo(1, 0)">客户资源分配</div>
      <div class="item flex-rowc" @click="handleGo(2)">更新客户信息</div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {
  getCustomerGenList,
  getCustomerDisList,
  getCustomerDetail,
  encryptstringadd,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "rAllocationDetail",
  data() {
    return {
      tabIndex: 0,
      id: "",

      // 触达记录
      paramsC: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        customerid: "",
      },
      loadingC: false,
      listTotalC: 0,
      dataListC: [],

      // 分配记录
      paramsF: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      },
      loadingF: false,
      listTotalF: 0,
      dataListF: [],

      customerDetail: "", // 客户详情
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }

    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.paramsC.customerid = id;
        this.paramsF.customerid = id;
        this.getCustomerDetail();
        this.getCustomerDisList();
      } else {
        this.$router.back();
      }
    },

    handleTab(index) {
      this.tabIndex = index;
      if (index == 0) {
        this.paramsF.pageindex = 1;
        this.dataListF = [];
        this.getCustomerDisList();
      } else if (index == 1) {
        this.paramsC.pageindex = 1;
        this.dataListC = [];
        this.getCustomerGenList();
      }
    },

    handleGo(type, id) {
      if (type == 1) {
        // this.$router.push(
        //   `/resourceIndex/rAllocationCustomer/${this.id}/${id}`
        // );
        this.encryptstringadd('rAllocationCustomer', {id: this.id, idC: id})
      } else if (type == 2) {
        // this.$router.push(`/resourceIndex/updateCustomer/${this.id}/2`);
        this.encryptstringadd('updateCustomer', {id: this.id, type: 2})
      } else if (type == 3) {
        // this.$router.push(`/resourceIndex/rServiceAddRecord/${this.id}/${id}`);
        this.encryptstringadd('rServiceAddRecord', {id: this.id, idC: id})
      }
    },

     // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
      });
    },
    // 获取触达数据
    getCustomerGenList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loadingC = true;
      getCustomerGenList(this.paramsC).then((res) => {
        this.dataListC = [...this.dataListC, ...res.list];
        this.listTotalC = res.total;
        this.loadingC = false;
        Toast.clear();
      });
    },

    // 获取分配记录
    getCustomerDisList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loadingF = true;
      getCustomerDisList(this.paramsF).then((res) => {
        this.dataListF = [...this.dataListF, ...res.list];
        this.listTotalF = res.total;
        this.loadingF = false;
        Toast.clear();
      });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (this.tabIndex == 0) {
        if (
          scrollTop + windowHeight >= documentHeight &&
          !this.loading &&
          this.dataListF.length < this.listTotalF
        ) {
          this.paramsF.pageindex += 1;
          this.getCustomerDisList();
        }
      } else {
        if (
          scrollTop + windowHeight >= documentHeight &&
          !this.loading &&
          this.dataListC.length < this.listTotalC
        ) {
          this.paramsC.pageindex += 1;
          this.getCustomerGenList();
        }
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detailPage {
  padding: 50px 50px 260px;
  .customer_wrap {
    font-size: 22px;
    color: #3c3c3c;
    width: 650px;
    margin: 0 auto 30px;
    margin-bottom: 30px;
    .red {
      color: #ff0036;
    }
    .customer_list {
      border: 1px solid #d2d2d2;
      padding: 40px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .item {
        margin-bottom: 45px;
        .txt {
          margin-bottom: 15px;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            white-space: nowrap;
            width: 160px;
            flex-shrink: 0;
          }
          .label_list {
            .label_item {
              border: 1px solid #d2d2d2;
              padding: 5px 10px 5px 20px;
              margin-right: 10px;
            }
          }
          .icon_wrap {
            a {
              color: #3c3c3c;
            }
            .icon-dianhua {
              margin-right: 40px;
            }
          }
        }
        &.address {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            font-size: 20px;
            p {
              &:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
        p {
          line-height: 28px;
        }
      }
    }
  }
  .main_wrap {
    .tab_head {
      height: 90px;
      border-bottom: 1px solid #898989;
      font-size: 30px;
      color: #000000;
      margin-bottom: 35px;
      background: #fff;
      .tab_item {
        flex: 1;
        text-align: center;
        position: relative;
        height: 90px;
        line-height: 90px;
        &.active {
          &::after {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 9px;
            background: #898989;
            display: inline-block;
            content: "";
          }
        }
      }
    }
    .record_list {
      border: 1px solid #d2d2d2;
      padding: 40px;
      box-sizing: border-box;
      font-size: 22px;
      color: #3c3c3c;
      margin-bottom: 30px;
      .red {
        color: #ff0036;
      }
      .block {
        .txt {
          margin-bottom: 20px;
          .label {
            width: 160px;
          }
        }
      }
      .remark {
        margin: 40px 0 35px;
        p {
          font-size: 20px;
          color: #828282;
          margin-top: 15px;
          line-height: 32px;
        }
      }
      .more {
        .box {
          width: 90px;
          height: 40px;
          border: 1px solid #aaaaaa;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>